<template>
    <b-container fluid class="mt--7">
        <b-card class="border-0">
            <b-card-body>
                <b-row>
                    <b-col>
                        <h4 class="mb-4">
                            {{ editMode ? 'Create' : 'View' }} Service Request
                        </h4>
                    </b-col>
                    <b-col v-if="!editMode">
                        <h5>Reference Number: {{ model.reference_no }}</h5>
                    </b-col>
                    <b-col v-if="!editMode && model.completed_by">
                        <h5>
                            Completion Date: {{ model.completed_by.split(' ') }}
                        </h5>
                    </b-col>
                </b-row>
                <b-form @submit.stop.prevent="createOrder" ref="customerForm">
                    <b-form-group
                        id="input-group-type"
                        label="Type:"
                        label-for="input-type"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-type"
                            v-model="model.order_type_id"
                            :disabled="!editMode"
                            :options="orderTypes | mapOptions"
                            required
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled
                                    >Select Activity Type</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="input-group-category"
                        label="Category:"
                        label-for="input-category"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-category"
                            v-model="model.request_category_id"
                            :disabled="!editMode"
                            :options="categories | mapOptions"
                            required
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >Select Category If
                                    Applicable</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="input-group-description"
                        label="Description:"
                        label-for="input-description"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-textarea
                            id="input-description"
                            v-model="model.description"
                            :disabled="!editMode"
                            placeholder="Brief description of activity..."
                            rows="3"
                            max-rows="4"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-form-group
                        id="input-group-date"
                        label="Due Date:"
                        :disabled="!editMode"
                        label-for="input-date"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-date"
                            v-model="model.date"
                            type="date"
                            :disabled="!editMode"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-time"
                        label="Due Time:"
                        label-for="input-time"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-time"
                            :disabled="!editMode"
                            v-model="model.time"
                            type="time"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="location-group"
                        label=" Service Location"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                        :disabled="!editMode"
                    >
                        <location-section
                            ref="locationSection"
                            v-model="model.delivery_location_section_id"
                            @update-section-model="updateLocationSection"
                            :hide-controls="true"
                            title="Service Location"
                            modal-title="Service Location"
                            :is-modal="true"
                        >
                            <b-button
                                @click="$refs.locationSection.setSearchMode()"
                                variant="secondary"
                                :disabled="!editMode"
                                style="margin-right: 5px"
                                >Change Location</b-button
                            >
                            <b-button
                                class="mr-2"
                                variant="warning"
                                @click="$refs.locationSection.hideModal()"
                                >Cancel</b-button
                            >
                        </location-section>
                    </b-form-group>
                    <b-form-group
                        id="input-group-driver"
                        label="Assigned To:"
                        label-for="input-driver"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            v-if="!editMode"
                            id="input-driver"
                            :value="officer_name"
                            readonly
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-group-note"
                        label="Comments:"
                        label-for="input-note"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-textarea
                            id="input-note"
                            :disabled="!editMode"
                            v-model="model.note"
                            placeholder="Enter Comments..."
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-form-group
                        id="input-group-Images"
                        label="Images:"
                        label-for="input-Images"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <ManageAttachments
                            v-model="isModalVisible"
                            :attachments="model.attachments"
                            @update-attachments="updateAttachments"
                        />
                    </b-form-group>

                    <div class="text-right">
                        <b-button
                            variant="success"
                            @click="showModal = !showModal"
                        >
                            Upload Attachment(s)
                        </b-button>
                        <b-button
                            type="submit"
                            class="my-4 ml-2"
                            variant="primary"
                            :disabled="submitting ? true : false"
                            >Submit</b-button
                        >
                    </div>
                </b-form>
                <b-modal
                    v-model="showModal"
                    id="add-attachments-modal"
                    centered
                    hide-footer
                    title="File(s) Upload"
                >
                    <b-row>
                        <b-col
                            sm="12"
                            xl="8"
                            v-if="this.filelist.length"
                            v-cloak
                        >
                            <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                            <b-list-group>
                                <b-list-group-item
                                    class="d-inline-flex p-2"
                                    v-for="(file, i) in filelist"
                                    :key="i"
                                >
                                    <!--file name input to rename the file before upload-->
                                    <b-form-input
                                        placeholder="File name..."
                                        v-model="filelist[i].fileName"
                                        required
                                        @change="
                                            renameFile(i, filelist[i].fileName)
                                        "
                                    />

                                    <!--file extension-->
                                    <span
                                        class="d-inline-flex align-items-center text-muted ml-1 mr-3"
                                        >.{{ filelist[i].extension }}</span
                                    >

                                    <!--remove file from list (and from upload)-->
                                    <b-button
                                        variant="outline-danger"
                                        size="sm"
                                        @click="remove(filelist.indexOf(file))"
                                    >
                                        <b-icon-trash></b-icon-trash>
                                    </b-button>
                                </b-list-group-item>
                            </b-list-group>
                        </b-col>

                        <!--this column contains the file drop area-->
                        <!--its width is automatically set based on existance of the file list column and breakpoint-->
                        <b-col class="file-drop-column my-4 my-xl-0 p-0">
                            <div
                                class="file-drop-area bg-light"
                                @dragover="dragover"
                                @drop="drop"
                            >
                                <!--we need an actual file input in order to have the drag&drop functionality-->
                                <!--and the File object(s) containing the files dropped-->
                                <!--We keep it invisible because we want to display something different than a file input-->
                                <input
                                    type="file"
                                    name="file-input"
                                    id="file-input"
                                    class="file-input invisible"
                                    @change="onChange"
                                />

                                <!--clicking on this label will trigger the clicked event on the file input-->
                                <!--this will cause the 'choose file' system dialog-->
                                <label
                                    for="file-input"
                                    class="w-100 text-center cursor-pointer text-muted m-0 px-3 py-5"
                                >
                                    <p>
                                        <b-icon-cloud-upload-fill
                                            font-scale="3"
                                        ></b-icon-cloud-upload-fill>
                                    </p>
                                    <div>
                                        <p class="mb-0">
                                            Drop your file(s) here
                                        </p>
                                        <p class="mb-0">
                                            or
                                            <span class="text-info"
                                                >choose from computer</span
                                            >
                                        </p>
                                    </div>
                                </label>
                            </div>
                        </b-col>
                    </b-row>

                    <div class="float-right mt-4">
                        <b-button
                            variant="secondary"
                            @click="$bvModal.hide('add-attachments-modal')"
                            class="mr-3"
                        >
                            Cancel
                        </b-button>
                        <b-button
                            type="submit"
                            :disabled="!filelist.length"
                            variant="success"
                            @click="onSubmit()"
                        >
                            Upload file(s)
                        </b-button>
                    </div>
                </b-modal>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import orderHelperMixins from '@/mixins/orderHelperMixins'
import popupMixins from '@/mixins/popupMixins'
import LocationSection from '@/views/Location/LocationSection'
import ManageAttachments from './ManageAttachments.vue'

const scheduledDate = new Date(Date.now() + 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
const scheduledTime = '09:30:00'

export default {
    name: 'create-order-form',
    components: { LocationSection, ManageAttachments },
    mixins: [popupMixins, orderHelperMixins],
    props: ['item'],
    data: () => {
        return {
            componentName: 'Service Request',
            isModalVisible: false,
            editMode: true,
            model: {
                order_type_id: null,
                request_category_id: null,
                description: null,
                driver_id: null,
                date: scheduledDate,
                time: scheduledTime,
                signature: false,
                delivery_location_section_id: null,
                attachments: [],
                note: null,
            },
            filelist: [],
            // attachment: null,
            // Controls Filepicker modal
            showModal: false,
            hasErrors: false,
        }
    },
    filters: {
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('requestCategory/fetchAll')
        this.$store.dispatch('users/fetchAll')
        this.model.date = scheduledDate
        console.log('scheduledDate', scheduledDate)

        this.$store.dispatch('js_report/fetchCredentials')
    },
    mounted() {
        this.model.delivery_location_section_id =
            this.customer && this.customer.location_section_id

        if (this.item.id) {
            this.model = { ...this.item }
            this.editMode = false
        }
        console.log('item', this.model)
    },

    computed: {
        submitting() {
            return this.$store.state.customerPortal.loading
        },
        customer() {
            return this.$store.state.customerPortal.customer
        },
        orderTypes() {
            let orderTypes = this.$store.state.orderType.items

            orderTypes = orderTypes
                .filter(x => !!x.is_customer_portal_visible)
                .map(x => ({
                    id: x.id,
                    name: x.customer_portal_name,
                }))
            console.log('orderTypes', orderTypes)
            return orderTypes
        },
        categories() {
            const categories = this.$store.state.requestCategory.categories
            console.log('categories', categories)
            return categories
        },
        officers() {
            const _officers = this.$store.getters['users/sorted_officers']
            console.log('_officers', _officers)
            return _officers
        },

        officer_name() {
            const officer = this.officers.find(
                x => x.id === this.model.driver_id
            )
            return (officer && officer.name) || ''
        },
    },
    watch: {},
    methods: {
        onSubmit() {
            event.preventDefault()

            console.log(this.filelist)
            this.uploadFile()
        },

        updateAttachments(evt) {
            this.model.attachments.splice(0)
            for (let attachment of evt) {
                this.model.attachments.push(attachment)
            }

            this.genericToast(
                this.componentName + ' Attachment',
                'Uploaded',
                'success',
                `Attachment successfully uploaded`
            )
        },
        async createOrder() {
            try {
                const model = { ...this.model }

                if (!model.order_type_id)
                    throw new Error('Activity Type Must Be selected')

                /*  if (!model.request_category_id)
                    throw new Error('Request Category Must Be selected') */

                model.schedule_at = this.getScheduleAt(model.date, model.time)

                console.log('model', model)
                const valid = await this.$validator.validate()
                if (!valid) {
                    throw new Error('Invalid Entry!!')
                }

                const data = await this.$store.dispatch(
                    'customerPortal/createOrder',
                    model
                )

                this.genericToast(
                    this.componentName,
                    'Created',
                    'success',
                    `${this.componentName} successfully created`
                )

                setTimeout(() => {
                    this.$refs.customerForm.reset()
                    this.$router.push('/customer-portal/service-requests')
                }, 1300)
                console.log(data)
            } catch (err) {
                console.log(err)
                this.doToast('Invalid', err.message, 'danger')
            }
        },
        renameFile(fileIndex, newName) {
            const file = this.filelist[fileIndex].file
            var newFile = new File(
                [file],
                `${newName}.${this.filelist[fileIndex].extension}`,
                {
                    type: file.type,
                }
            )

            // Rebuild File Obj for file list array
            const fileName = newFile.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
            const extension = newFile.name.split('.').pop() //extract

            this.filelist[fileIndex] = {
                fileName: fileName,
                extension: extension,
                file: newFile,
            }
        },
        onChange(event) {
            const fileArray = [...event.target.files] //put the files in a temporary array
            fileArray.forEach(file => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                this.filelist.push({
                    fileName: fileName,
                    extension: extension,
                    file: file,
                }) //store selected files and additional data in our array
            })
        },
        remove(i) {
            this.filelist.splice(i, 1)
        },
        dragover(event) {
            event.preventDefault()
        },
        drop(event) {
            event.preventDefault()
            this.onChange()
        },
        uploadFile() {
            // console.log('upload event', event)
            let files = []

            for (const file of this.filelist) {
                files.push(file.file)
            }

            const $this = this
            if (!navigator.geolocation) {
                console.log('problem with navigator')

                this.genericToast(
                    this.componentName,
                    'Error',
                    'danger',
                    'Error Adding Attachment! Need Permissions to Get Coordinates'
                )

                // $this.doToast(
                //     'Error!',
                //     'Error Adding Attachment! Need Permissions to Get Coordinates',
                //     'danger'
                // )
            } else
                navigator.geolocation.getCurrentPosition(async p => {
                    try {
                        console.log('coordinates', p)
                        const lat = p.coords.latitude
                        const long = p.coords.longitude

                        const { key, name } = await $this.$store.dispatch(
                            's3files/s3upload',
                            files
                        )

                        const url = `${$this.$OMSStorageUrl}/${key}`
                        console.log({ key, name, url })

                        const payload = { url, lat, long }
                        payload.order_id = $this.order.id

                        await $this.$store.dispatch(
                            'customerPortal/createAttachment',
                            payload
                        )

                        $this.$store.dispatch(
                            'customerPortal/fetchOrder',
                            $this.order.id
                        )
                        this.genericToast(
                            this.componentName,
                            'Uploaded',
                            'success',
                            `Attachment has been succcessfully uploaded`
                        )
                        // Hide modal after success
                        this.showModal = false
                        // $this.doToast(
                        //     'Image Added!',
                        //     'Attachment Added!',
                        //     'success'
                        // )
                    } catch (error) {
                        console.error('addAttachement', error)

                        $this.doToast(
                            'Error!',
                            'Error Adding Attachment!',
                            'danger'
                        )
                    } finally {
                        $this.submitting = false
                    }
                })
        },
        updateLocationSection(locationData) {
            locationData = locationData || {}
            for (const key in locationData) {
                this.$set(this.model, key, locationData[key])
            }

            // this.genericToast(
            //     'Service Location',
            //     'Added',
            //     'success',
            //     `Service Location successfully added`
            // )
        },
    },
}
</script>
